import {
  faBan,
  faMicrochip,
  faPencilAlt,
  faTrashAlt,
} from "@fortawesome/free-solid-svg-icons";
import { observer } from "mobx-react";
import React, { SyntheticEvent, useEffect, useState } from "react";
import { FormattedMessage } from "react-intl";
import { useHistory } from "react-router-dom";
import SlidingPanel from "react-sliding-side-panel";
import fotaFileTypeEnum from "../../constants/fota-file-type-enum";
import FotaStatusEnum from "../../constants/fota-status-enum";
import fotaViewTypeEnum, {
  ModuleToOpen,
} from "../../constants/fota-view-type-enum";
import systemModuleEnum from "../../constants/system-module-enum";
import userSettingEnum from "../../constants/user-setting-enum";
import { useStore } from "../../contexts/StoreProvider";
import {
  isOperationPermitted,
  showIcons,
} from "../../helpers/action-permission-helper";
import IPageInfo, {
  IActionFormatter,
  IPageLimitInfo,
} from "../../models/ICommon";
import {
  IFotaDeviceStatusParentData,
  IFotaHostScheduleList,
} from "../../models/response/IFotaNewResponse";
import FormLoader from "../../shared-components/FormLoader/FormLoader";
import Grid from "../../shared-components/Grid/Grid";
import Pagination from "../../shared-components/Grid/Pagination";
import AbortPopupHOC from "../../shared-components/popup/abort/abort-popup-hoc";
import AddPopupHOC from "../../shared-components/popup/add/add-popup-hoc";
import DeletePopup from "../../shared-components/popup/delete/delete-popup";
import DeletePopupHOC from "../../shared-components/popup/delete/delete-popup-hoc";
import ShowPopupHOC from "../../shared-components/popup/show/show-popup-hoc";
import RoutesConstants from "../../shared-components/Routes/routes.constants";
import { formatMessage } from "../../translations/format-message";
import ScheduleFirmwareUpdate from "./components/schedule-firmware-update";
import "./fota-tnt-release";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import AbortIconSVG from "../../shared-components/svg/abort";
import DisableAbortIconSVG from "../../shared-components/svg/disable-abort";
import CantAbortIconSVG from "../../shared-components/svg/cant-abort";
import _ from "lodash";
import toast from "react-hot-toast";
import FotaModemDetails from "./components/fota-modem-detail";
import LoaderButton from "../../shared-components/Button/LoaderButton";
import no_user from "../../assets/Images/svg/nofotajet.svg";

const FotaModemView = (props: any) => {
  const history = useHistory();
  const { preferencesStore, fotaTntReleaseStore, schedulerHistoryStore } = useStore();
  const {
    addUpdateFotaState,
    resetAddUpdateFotaState,
    inProgress,
    GetModemConfigListService,
    getModemConfigList,
    fotaModemConfigList,
    deleteFotaModemScheduleState,
    GetFotaModemScheduleListService,
    getFotaModemScheduleList,
    DeleteFotaModemScheduleService,
    resetDeleteFotaModemScheduleState,
    fotaModemScheduleList,
    setSelectedView,
    isSelectedView,
    isAddUpdatePopupOpen,
    setIsAddUpdatePopupOpen,
    filterDetails,
    setFilterDetail,
  } = fotaTntReleaseStore;
  const {
    userSetting,
    setUserSetting,
    islanguageChanged,
    updateLanguageChangedFlag,
  } = preferencesStore;
  const {
    AbortFotaDeviceModemScheduleByScheduleIdService,
    abortDeviceScheduleState,
    resetAbortDeviceScheduleState,
  } = schedulerHistoryStore;
  const {
    selectedId,
    setSelectedId,
    selectedRow,
    setSelectedRow,
    openPanel,
    setOpenPanel,
    closePanelHandler,
    pageInfo,
    setPageInfo
  } = props;
  const pageLimitOptions: Array<number> = [10, 50, 100, 1000];
  const [disablePagination, setDisablePagination] = useState<boolean>(false);

  const [pageLimitInfo, setPageLimit] = useState<IPageLimitInfo>({
    pageLimit: userSetting.fotaLimitConfig,
    isPageLimitChange: false,
  });

  const onPageChanged = (pageNumber: number) => {
    setPageInfo({ ...pageInfo, currentPage: pageNumber, isPagerChange: true });
  };

  const setIsRefreshPage = () => {
    setPageInfo({ ...pageInfo, isRefreshPage: false });
  };

  const onPageLimitChanged = (evt: any) => {
    setPageInfo({
      ...pageInfo,
      currentPage: 1,
      totalPages:
        isSelectedView.moduleToOpen === ModuleToOpen.Config
          ? fotaModemConfigList?.PagingDetails?.TotalPages
          : fotaModemScheduleList?.PagingDetails?.TotalPages,
      isPagerChange: false,
    });
    setPageLimit({
      pageLimit: parseInt(evt.target.value),
      isPageLimitChange: true,
    });
    setUserSetting(userSettingEnum.FotaLimitConfig, parseInt(evt.target.value));
  };


  const callGetFotaModemListService = () => {
    if (isSelectedView.view == fotaViewTypeEnum.Modem && isSelectedView.moduleToOpen === ModuleToOpen.Config) {
      GetModemConfigListService(
        pageInfo.currentPage,
        pageLimitInfo.pageLimit
      );
    }
    else if (isSelectedView.view == fotaViewTypeEnum.Modem && isSelectedView.moduleToOpen === ModuleToOpen.Schedule) {
      GetFotaModemScheduleListService(
        pageInfo.currentPage,
        pageLimitInfo.pageLimit,
        filterDetails
      );
    }
  };

  /**
   * This function shows the add group pop up from where we can add new group and update existing group prootcol. we use id to identify
   * that we are adding or updating group.
   * "Id == -1" : we are adding new group
   * "Id != -1" : means we are updating existing group
   */
  const openAddPopupHandler = (row: { Id: number }, event: SyntheticEvent) => {
    event.stopPropagation();
    closePanelHandler();
    setSelectedId(row.Id);
    setIsAddUpdatePopupOpen(true);
  };
  /**
   * This function shows the delete user confirmation popup component and sets the seleted user Id
   */
  const deleteClickHandler = (row: { Id: number }, event: SyntheticEvent) => {
    event.stopPropagation();
    setSelectedId(row.Id);
    props.deletePopupToggleHandler();
  };

  const historyClickHandler = (
    row: IFotaHostScheduleList,
    event: SyntheticEvent,
    isSelectedTabView: fotaViewTypeEnum
  ) => {
    event.stopPropagation();
    let tempState: IFotaDeviceStatusParentData = {
      Id: row.Id,
      ScheduleDate: row.ScheduleDate,
      ScheduleExpirationDate: row.ScheduleExpirationDate,
      Version: row.ConfigVersion,
      FileType: row.Config?.FileType || 0,
    };
    history.push({
      pathname: RoutesConstants.FotaDeviceStatus,
      state: {
        selectedRecord: { ...tempState },
        isSelectedTabView
      },
    });
  };

  const abortHandler = () => {
    AbortFotaDeviceModemScheduleByScheduleIdService(selectedId);
  };

  const abortPopupOpenHandler = (
    row: IFotaHostScheduleList,
    event: SyntheticEvent
  ) => {
    event.stopPropagation();
    setSelectedId(row.Id);
    props.abortPopupToggleHandler();
  };

  /**
   * This function deletes the user by providing Id to the Api
   */
  const deleteHandler = () => {
    DeleteFotaModemScheduleService(selectedId);
  };

  useEffect(() => {
    if (deleteFotaModemScheduleState.success) {
      toast.success(formatMessage("deleted_success"));
      if (isSelectedView.moduleToOpen === ModuleToOpen.Schedule)
        resetDeleteFotaModemScheduleState();

      props.deletePopupToggleHandler();
      callGetFotaModemListService();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [deleteFotaModemScheduleState.success]);

  useEffect(() => {
    if (isSelectedView.view === fotaViewTypeEnum.Modem && addUpdateFotaState.success) {
      resetAddUpdateFotaState();
      callGetFotaModemListService();
    }
  }, [addUpdateFotaState.success]);

  useEffect(() => {
    if (abortDeviceScheduleState.success) {
      toast.success(formatMessage("abort_success"));
      setSelectedId(-1);
      resetAbortDeviceScheduleState();
      callGetFotaModemListService();
      props.abortPopupToggleHandler();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [abortDeviceScheduleState.success]);


  useEffect(() => {
    if (pageLimitInfo.isPageLimitChange) {
      callGetFotaModemListService();
      setPageLimit({ ...pageLimitInfo, isPageLimitChange: false });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageLimitInfo.pageLimit]);


  useEffect(() => {
    setPageInfo({
      ...pageInfo,
      totalPages:
        isSelectedView.moduleToOpen === ModuleToOpen.Config
          ? fotaModemConfigList?.PagingDetails?.TotalPages
          : fotaModemScheduleList?.PagingDetails?.TotalPages,
      isPagerChange: false,
    });
    setDisablePagination(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fotaModemConfigList, getFotaModemScheduleList]);


  useEffect(() => {
    if (filterDetails.isFilterActive) callGetFotaModemListService();
    else {
      callGetFotaModemListService();
    }
  }, [filterDetails]);

  useEffect(() => {
    if (isSelectedView.isViewChanged) {
      setSelectedView({ ...isSelectedView, isViewChanged: false });
      callGetFotaModemListService();
      setPageInfo({
        ...pageInfo,
        currentPage: 1,
        isRefreshPage: true,
        isPagerChange: true,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSelectedView.isViewChanged]);

  /**
   * The function we pass to the useEffect Hook runs when the component is mounted and when it is re-rendered while
   * dependency "pageInfo.currentPage" of the useEffect changed.
   */
  useEffect(() => {
    if (pageInfo.isPagerChange) {
      callGetFotaModemListService();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageInfo.currentPage]);



  /**
   * The function we pass to the useEffect Hook runs when the component is mounted and when it is re-rendered while
   * dependency "islanguageChanged" of the useEffect changed.
   */
  useEffect(() => {
    if (islanguageChanged) {
      callGetFotaModemListService();
      updateLanguageChangedFlag();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [islanguageChanged]);

  function rowClassFormat(row: any, rowIdx: number) {
    let className: string = "";
    if (selectedId && row.Id === selectedId) {
      className = "bg-row SelectedRow";
    }
    return className;
  }

  const rowEvents = (e: SyntheticEvent, row: any, rowIndex: number) => {
    setSelectedId(row.Id);
    setSelectedRow(row);
    setOpenPanel(true);
  };

  const getSelectedTabLandingpageNoRecordMessage = () => {
    if (isSelectedView.view == fotaViewTypeEnum.Modem && isSelectedView.moduleToOpen == ModuleToOpen.Config) {
      return <FormattedMessage id="no_fota_config" />;
    }
    else if (isSelectedView.view == fotaViewTypeEnum.Modem && isSelectedView.moduleToOpen == ModuleToOpen.Schedule) {
      return <FormattedMessage id="no_fota_schedule" />;
    }
  };
  const getSelectedTabLandingpageNoRecordFullMessage = () => {
    if (isSelectedView.view == fotaViewTypeEnum.Modem && isSelectedView.moduleToOpen == ModuleToOpen.Config) {
      return <FormattedMessage id="no_fota_config_msg" />;
    }
    else if (isSelectedView.view == fotaViewTypeEnum.Modem && isSelectedView.moduleToOpen == ModuleToOpen.Schedule) {
      return <FormattedMessage id="no_fota_schedule_msg" />;
    }
  };
  const getSelectedTabLandingpageButtonMessageKey = () => {
    if (isSelectedView.view == fotaViewTypeEnum.Modem && isSelectedView.moduleToOpen == ModuleToOpen.Schedule) {
      return "add_schedule";
    }
  };

  const getFotaFileTypeHandler = (fileType: fotaFileTypeEnum) => {
    if (fileType == fotaFileTypeEnum.NoConvert) return formatMessage("no_convert");
    else if (fileType == fotaFileTypeEnum.ASCII) return formatMessage("ASCII");
    else return "";
  };

  const actionIcons: IActionFormatter[] = showIcons(
    [
      {
        dataField: "isEdit",
        handler: openAddPopupHandler,
        icon: faPencilAlt,
        isDisable: false,
        title: "edit",
        action: "edit",
        varient: "primary",
      },
      {
        dataField: "isDelete",
        handler: deleteClickHandler,
        icon: faTrashAlt,
        isDisable: true,
        title: "delete",
        action: "delete",
        varient: "danger",
      },
    ],
    systemModuleEnum.Fota
  );

  const configColumns: any = [
    {
      dataField: "CreatedDate",
      text: formatMessage("created_date"),
    },
    {
      dataField: "ConfigName",
      text: formatMessage("fota_config_name"),
    },
    {
      dataField: "Version",
      text: formatMessage("version"),
    },
    {
      dataField: "FileType",
      text: formatMessage("sending_method"),
      formatter: (cell: any, row: any) => {
        return (
          <>
            <span>{getFotaFileTypeHandler(cell)}</span>
          </>
        );
      },
    },
    {
      dataField: "FileName",
      text: formatMessage("file_name")
    },
    {
      dataField: "Description",
      text: formatMessage("fota_desc"),
      title: (cell: string, row: any) => {
        return cell.length > 10 ? cell : undefined;
      },
    }
  ];

  const scheduleColumns: any = [
    {
      dataField: "ScheduleDate",
      text: formatMessage("schedule_date"),
    },
    {
      dataField: "ScheduleExpirationDate",
      text: formatMessage("schedule_expiration_date"),
    },
    {
      dataField: "ConfigName",
      text: formatMessage("fota_config_name"),
    },
    {
      dataField: "ConfigVersion",
      text: formatMessage("config_version"),
    },
    {
      dataField: "Description",
      text: formatMessage("fota_desc"),
      title: (cell: string, row: any) => {
        return cell.length > 10 ? cell : undefined;
      },
    },
    {
      dataField: "Status",
      formatter: (cell: number, row: any) => {
        return (<FormattedMessage id={FotaStatusEnum[cell]} />);
      },
      text: formatMessage("status"),
    },
    {
      dataField: "Progress",
      text: formatMessage("progress_percent"),
    },
    {
      dataField: "",
      text: formatMessage("actions"),
      hidden: actionIcons.length === 0 ? true : false,
      formatter: (cell: any, row: IFotaHostScheduleList) => {
        return (
          <>
            <div className="btn-group">
              {/* 
              [DeepakPaliwal, When Schedule Date fota works then will uncommnet this code section ]
              {isOperationPermitted(systemModuleEnum.Fota, "Edit") && (
                <button
                  className={`btn btn-outline-primary btn-sm`}
                  key="edit"
                  title={formatMessage("edit")}
                  type="button"
                  disabled={!row.isEdit}
                  onClick={(event) => openAddPopupHandler(row, event)}
                >
                  <FontAwesomeIcon icon={faPencilAlt} />
                </button>
              )} */}
              {isOperationPermitted(systemModuleEnum.Fota, "Delete") && (
                <button
                  className={`btn btn-outline-primary btn-sm`}
                  key="delete"
                  title={formatMessage("delete")}
                  type="button"
                  disabled={!row.isDelete}
                  onClick={(event) => deleteClickHandler(row, event)}
                >
                  <FontAwesomeIcon icon={faTrashAlt} />
                </button>
              )}
              {isOperationPermitted(systemModuleEnum.Fota, "View") && (
                <button
                  className={`btn btn-outline-primary btn-sm`}
                  key="fota_device_status"
                  title={formatMessage("fota_device_status")}
                  type="button"
                  disabled={!row.isHistory}
                  onClick={(event) => historyClickHandler(row, event, fotaViewTypeEnum.Modem)}
                >
                  <FontAwesomeIcon icon={faMicrochip} />
                </button>
              )}
              {isOperationPermitted(systemModuleEnum.Fota, "Edit") && (
                <button
                  className={`btn btn-outline-primary btn-sm`}
                  key="abort_schedule"
                  title={formatMessage((row.IsScheduleAborted || row.Status === FotaStatusEnum.Aborted) ? "schedule_aborted" : ((row.Status === FotaStatusEnum.Pending || row.Status === FotaStatusEnum.Success || row.Status === FotaStatusEnum.None || row.Status === FotaStatusEnum.Failed) ? "cant_abort" : "abort_schedule"))}
                  type="button"
                  disabled={!row.isAbort}
                  onClick={(event) => abortPopupOpenHandler(row, event)}
                >
                  {
                    (row.IsScheduleAborted || row.Status === FotaStatusEnum.Aborted) ?
                      <DisableAbortIconSVG /> :
                      // <AbortIconSVG /> :
                      ((row.Status === FotaStatusEnum.Pending || row.Status === FotaStatusEnum.Success || row.Status === FotaStatusEnum.None || row.Status === FotaStatusEnum.Failed) ?
                        <CantAbortIconSVG /> :
                        <AbortIconSVG />)
                  }
                </button>
              )}
            </div>
          </>
        );
      },
    },
  ];


  return (
    <>
      {isAddUpdatePopupOpen && (
        <>
          {isSelectedView.view === fotaViewTypeEnum.Modem &&
            isSelectedView.moduleToOpen === ModuleToOpen.Schedule && (
              <ScheduleFirmwareUpdate
                schedulerId={selectedId}
                modalClosed={() => {
                  setIsAddUpdatePopupOpen(false);
                }}
              />
            )}
        </>
      )}
      {props.showDeletePopup && (
        <DeletePopup
          title={"delete_modem_schedule"}
          modalSubmit={deleteHandler}
          modalClosed={props.deletePopupToggleHandler}
          message={"message_delete_modem_schedule_confirm"}
          isLoading={deleteFotaModemScheduleState.inProgress}
        />
      )}
      {/*Aort confirm popup */}
      {props.showAbortPopup && (
        <DeletePopup
          title="abort_schedule_confirm"
          modalSubmit={abortHandler}
          modalClosed={props.abortPopupToggleHandler}
          message="message_abort_modem_schedule_confirm"
          isLoading={abortDeviceScheduleState.inProgress}
        />
      )}
      <div className="table_items_list">
        {inProgress && <FormLoader loading={inProgress} />}
        {getModemConfigList.length > 0 ||
          getFotaModemScheduleList.length > 0 ? (
          <div
            className={`card mt-3 changingPanel ${openPanel ? "panelOpen" : ""
              }`}
          >
            <div className="tableDesign row-eq-height tableDevices ">
              <div className="table-responsive" data-testid="table">
                {isSelectedView.moduleToOpen === ModuleToOpen.Config ? (
                  <Grid
                    data={getModemConfigList}
                    columns={configColumns}
                    keyField="Id"
                    loading={inProgress}
                  />
                ) : (
                  <Grid
                    data={getFotaModemScheduleList}
                    columns={scheduleColumns}
                    keyField="Id"
                    loading={inProgress}
                    rowEvents={{ onClick: rowEvents }}
                    rowClasses={rowClassFormat}
                  />
                )}
              </div>
            </div>

            {(getModemConfigList.length > 0 || getFotaModemScheduleList.length > 0) ? (
              <div className="row g-0 p-2 tableFooter">
                <div className="col-sm-6 pt-1">
                  <FormattedMessage id="show" />
                  <select
                    data-testid="pageSelect"
                    className="pageLimit"
                    onChange={onPageLimitChanged}
                    value={pageLimitInfo.pageLimit}
                  >
                    {pageLimitOptions.map((op: any) => (
                      <option key={op} value={op}>
                        {op}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="col-sm-6 d-flex justify-content-sm-end">
                  <Pagination
                    isRefreshPage={false}
                    totalPages={pageInfo.totalPages}
                    pageLimit={pageLimitInfo.pageLimit}
                    onPageChanged={onPageChanged}
                    disablePagination={disablePagination}
                    setIsRefreshPage={setIsRefreshPage}
                  />
                </div>
              </div>
            ) : (
              ""
            )}
          </div>
        ) : (
          <div className="message text-center">
            <img src={no_user} alt="" className="no_message" />
            <p className="noData text-muted text-center h4 mb-0">
              {
                getSelectedTabLandingpageNoRecordMessage()
              }
            </p>
            <p className="mb-3">{getSelectedTabLandingpageNoRecordFullMessage()}</p>
            {isOperationPermitted(systemModuleEnum.Fota, "Add") && isSelectedView.moduleToOpen != ModuleToOpen.Config && (
              <LoaderButton
                text={getSelectedTabLandingpageButtonMessageKey()}
                onClick={(e: React.MouseEvent<HTMLButtonElement, MouseEvent>) =>
                  openAddPopupHandler({ Id: -1 }, e)
                }
              />
            )}
          </div>
        )}
      </div>
      <SlidingPanel
        type={"right"}
        isOpen={openPanel}
        noBackdrop={false}
        size={100}
      >
        <div className="bg_slide panel order_details_panel">
          <div className="row bb p-2 g-0">
            <div className="col-lg-11">
              <h2 className="fw-bold mb-0 mt-2">{selectedRow.ScheduleDate}</h2>
            </div>
            <div className="col-lg-1 text-end">
              <button
                onClick={closePanelHandler}
                className="Crossicons"
                title={formatMessage("close")}
              >
                <svg
                  role="button"
                  xlinkTitle="close"
                  xmlns="http://www.w3.org/2000/svg"
                  width="30"
                  height="30"
                  fill="currentColor"
                  className="bi bi-x"
                  viewBox="0 0 16 16"
                >
                  <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
                </svg>
              </button>
            </div>
          </div>
          <FotaModemDetails selectedData={selectedRow} />
        </div>
      </SlidingPanel>
    </>
  );
};

export default AbortPopupHOC(
  DeletePopupHOC(ShowPopupHOC(AddPopupHOC(observer(FotaModemView))))
);
